import React from 'react'

export default function MainHeading({title, spanTitle, id}) {
  return (
   <h1 id={id} className='main-heading'>{title} <span>{spanTitle}</span></h1>
  )
}
